import { render } from "./ProgressBar.vue?vue&type=template&id=9c1a8c8e&bindings={\"completed\":\"props\",\"total\":\"props\",\"completedPercent\":\"options\"}"
import script from "./ProgressBar.vue?vue&type=script&lang=js"
export * from "./ProgressBar.vue?vue&type=script&lang=js"
script.render = render

export default script
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLinearProgress});
